export default __webpack_public_path__ + "static/media/check-24px.63aa8fec.svg";